<template>
  <slice
    :id="block._key"
    class="block-preorder-explain container"
    :custom-intersection-options="{
      root: null,
      rootMargin: '100px 0px 100px 0px',
      threshold: [0, 1],
    }"
    @in="onScreen"
    @out="$emit('out')"
  >
    <h2>{{ $t('preorder.explain.title') }}</h2>

    <p>
      {{ $t('preorder.explain.text_1') }}
    </p>

    <p>
      {{ $t('preorder.explain.text_2') }}
    </p>

    <p>
      {{ $t('preorder.explain.text_3') }}
    </p>

    <slider
      v-if="hasPreorderExplain"
      :number-of-children="siteSettings.preorder_explain.length"
      :width="320"
      :gap="15"
      :hide-nav-on-edges="false"
    >
      <div v-for="step in siteSettings.preorder_explain" :key="step._key">
        <div class="block-preorder-explain__img">
          <lazy-image :image="getImage(step.image)" sizes="320w" />
        </div>

        <div class="pt-0-6 lh-1-2">
          <p class="text-small text-uppercase w-600 mb-0-2">
            {{ step.title }}
          </p>
          <p class="text-small mb-0">
            {{ step.description }}
          </p>
        </div>
      </div>
    </slider>
  </slice>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import Slice from '@/components/Slices/Slice'
import Slider from '@/components/slider/Slider'

import LazyImage from '@/components/Image/LazyImage'
import { getSanityBunnyImageLink } from '~/utils/image'

export default {
  title: 'PreorderExplainText',
  components: { Slice, Slider, LazyImage },
  props: {
    block: { type: Object, required: true },
  },
  data: () => ({}),
  computed: {
    ...mapGetters({
      globalLoading: 'global/loading',
      siteSettings: 'global/siteSettings',
    }),
    hasPreorderExplain() {
      return (
        this.siteSettings?.preorder_explain &&
        this.siteSettings.preorder_explain.length > 0
      )
    },
  },

  methods: {
    ...mapActions({
      getSiteSettings: 'global/getSiteSettings',
    }),
    onScreen() {
      if (!this.siteSettings && !this.globalLoading) {
        this.getSiteSettings()
      }

      this.$emit('in')
    },
    getImage(image) {
      if (image._type === 'image_per_context') {
        const context = this.$route.params.context
        const imagePerContext = image.image.find((img) => img._key === context)

        if (imagePerContext) {
          return {
            url: getSanityBunnyImageLink(imagePerContext, {
              width: 320,
              height: 100,
            }),
            dimensions: {
              width: 320,
              height: 100,
            },
          }
        }
      } else {
        return {
          url: getSanityBunnyImageLink(image, {
            width: 320,
            height: 100,
          }),
          dimensions: {
            width: 320,
            height: 100,
          },
        }
      }

      return null
    },
  },
}
</script>

<style lang="scss">
.block-preorder-explain {
  overflow: hidden;
  padding: calc(var(--spacing) * 2) var(--spacing);

  @include mq($from: tablet) {
    padding: calc(var(--spacing) * 4) calc(var(--spacing) * 3);
  }

  .slider-nav {
    display: flex;
    justify-content: flex-end;
    gap: var(--spacing);
    padding-top: calc(var(--spacing) * 2);

    .action {
      position: static;
      width: rem(50px);
      height: rem(50px);
      background-color: var(--secondary-color);
      border-radius: 12px;
      padding: 0;

      .action__inner {
        justify-content: center;
      }

      &.slider-nav--edge {
        background: RGB(0 46 93 / 0.4);
      }
    }
  }
}

.block-preorder-explain__img {
  min-height: rem(60px);
  padding: calc(var(--spacing) * 0.6) 0 calc(var(--spacing) * 0.8);
  display: flex;
  justify-content: flex-start;
  align-items: center;

  @include mq($until: tablet) {
    min-height: rem(120px);
    background-color: var(--tertiary-color);
    justify-content: center;
  }
}
</style>
